export const formatTimeToReadable = (current) => {
  var h = Math.floor(current / 3600);
  var m = Math.floor((current - h * 3600) / 60);
  // var s = Math.floor(current % 60);

  if (h > 0) {
    return `${h}h ${m}min(s)`;
  } else {
    return `${m} minute(s)`;
  }
};

export const formatTime = (current) => {
  var h = Math.floor(current / 3600);
  var m = Math.floor((current - h * 3600) / 60);
  var s = Math.floor(current % 60);

  if (s < 10) {
    s = "0" + s;
  }

  if (h > 0) {
    m = m < 10 ? "0" + m : m;
    h = h < 10 ? "0" + h : h;
    return `${h}:${m}:${s}`;
  } else {
    return `${m}:${s}`;
  }
};
